/**
 * The User session related query parameters.
 * @type {Object<String>}
 */
export const QUERY_PARAMS = {
    SHOW_JOIN: 'show_join',
    REFERRAL_EMAIL: 'referral_email'
};

/**
 * The redirect url cookie name.
 * @type {String}
 */
export const REDIRECT_COOKIE = 'redirect_url';

/**
 * The redirect cookie expires in time in milliseconds.
 * @type {Number}
 */
export const REDIRECT_EXPIRES_IN = 5 * 60 * 1000;

/**
 * The sign in HTML selector that when present, should trigger the login modal show.
 * @type {String}
 */
export const SIGN_IN_SELECTOR = '.js-open-popup-login';

/**
 * The sign up HTML selector that when present, should trigger the login modal show.
 * @type {String}
 */
export const SIGN_UP_SELECTOR = '.js-open-popup-join';

/**
 * The session storage key for managing an auto shown sign up modal.
 * @type {string}
 */
export const SIGN_UP_AUTO_SHOWN_KEY = 'sign_up_auto_shown';

/**
 * The auto show trigger reason to be reported on auto show sign up flow.
 * @type {string}
 */
export const AUTO_SHOW_TRIGGER = 'system_trigger';

/**
 * The User session modal handler types
 * @type {Object<String>}
 */
export const HANDLER_TYPES = {
    SIGN_IN: 'sign_in',
    SIGN_UP: 'sign_up'
};

/**
 * The User session fallback route mapped by the handler type.
 * @type {Object<String>}
 */
export const FALLBACK_ROUTES = {
    [HANDLER_TYPES.SIGN_IN]: 'login',
    [HANDLER_TYPES.SIGN_UP]: 'join'
};
